import { z } from 'zod';

export const EnvSchema = z.record(
  z.string().regex(/^(?!.*\b(host|hostname|origin|locale)\b).+$/, {
    message: "String cannot contain 'host' or 'hostname'",
  }),
  z.string(),
);
